<template>
  <!-- 责问者库 -->
  <div class="section home-author" clickTitle @toList="toBaseList">
    <home-title title="人才库" clickTitle @toList="toBaseList" />
    <div class="container">
      <swiper class="author-pics" ref="rcSwiper" :options="options" v-if="list && list.length">
        <swiper-slide class="item" @click.native="goDetail(item)" v-for="(item, index) in list" :key="index">
          <div class="kuang"><em></em></div>
          <div class="name">{{ item.name }}</div>
          <div class="item-pic">
            <p :style="{ 'background-image': `url(${item.cover_img})` }"><img
                :src="item.cover_img" />
            </p>
          </div>
          <div class="des">
            <span v-for="(v, i) in item.typeList" :key="i">{{ v }}</span>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>
    <div class="flex jc">
      <div class="homeBottomMoreBtn" @click="toMore">
        <em>查看更多</em>
      </div>
    </div>
  </div>
</template>

<script>
import homeTitle from './home-title.vue'
import { swiper, swiperSlide } from "vue-awesome-swiper"

export default {
  components: { homeTitle, swiper, swiperSlide },
  name: 'zrzk',
  props: {
    msg: String
  },
  data() {
    return {
      options: {
        slidesPerView: 9,
        slidesPerGroup: 9,
        spaceBetween: 20,
        observer: true,
        observeParents: true,
        speed: 600,
        navigation: {
          nextEl: '.home-author .swiper-button-next',
          prevEl: '.home-author .swiper-button-prev'
        },
      },
      showpath: '',
      list: [],
      swiperPageIndex: 1,
      peopleSwiper: null
    }
  },
  mounted() {
    this.getArtistList()
  },
  methods: {
    // 人才库内容
    async getArtistList() {
      let params = {
        page: 1,
        pageSize: 36
      }
      const res = await this.$api.artistApi.GetListHasHeadRecommend(params)
      this.showpath = res.showpath;
      let list = res.data || []
      list = this.$utils.randomList(list)
      list = await Promise.all(
        list.map(async (v) => {
          return {
            ...v,
            cover_img: this.setImage(res.showpath, v.cover_img, `?x-oss-process=image/resize,m_fill,w_100,h_100`, true),
          };
        })
      );
      this.list = list.map(v => {
        const types = v.artisttype ? v.artisttype.split(',') : []
        return {
          ...v,
          typeList: types.filter((v, i) => i <= 2)
        }
      })
      this.initSwiper()
    },
    initSwiper() {
      const _t = this
      if (this.$refs.rcSwiper) {
        this.peopleSwiper = this.$refs.rcSwiper.swiper
        this.peopleSwiper.init()
      } else {
        setTimeout(() => {
          _t.initSwiper()
        }, 100)
      }
    },
    toBaseList() {
      this.$router.push('/artist')
    },
    toMore() {
      this.$router.push({ path: "artist" });
      // this.$router.push({ name:'Login', params: { id: this.id } )
    },
    goDetail(info) {
      this.$router.push({
        path: "artist/" + info.id
      })
    }
  }
}
</script>